/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Browse_AriaInputs */

const en_directory_rails_browse_aria = /** @type {(inputs: Directory_Rails_Browse_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse the directory`)
};

const zh_directory_rails_browse_aria = /** @type {(inputs: Directory_Rails_Browse_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览目录`)
};

/**
* | output |
* | --- |
* | "Browse the directory" |
*
* @param {Directory_Rails_Browse_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_browse_aria = /** @type {((inputs?: Directory_Rails_Browse_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Browse_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_browse_aria(inputs)
	return zh_directory_rails_browse_aria(inputs)
});
export { directory_rails_browse_aria as "directory.rails.browse_aria" }